import { useIntl } from 'react-intl'
import styled from 'styled-components'

import autotaxLogoSrc from '@assets/img/szlahu_orange_black.svg'
import autotaxShortLogoSrc from '@assets/img/szlahu_orange_black_short.svg'

import { logoMessages } from './messages'

export interface AssetLogoProps {
  className?: string
  /** Rendered height in px; width follows the artwork's aspect ratio. */
  size?: number
}

const LogoImg = styled.img`
  display: block;
  width: auto;
`

export function AutotaxLogo({ className, size = 32 }: AssetLogoProps) {
  const { formatMessage } = useIntl()

  return <LogoImg alt={formatMessage(logoMessages.autotax)} className={className} height={size} src={autotaxLogoSrc} />
}

export function AutotaxShortLogo({ className, size = 24 }: AssetLogoProps) {
  const { formatMessage } = useIntl()

  return (
    <LogoImg alt={formatMessage(logoMessages.autotax)} className={className} height={size} src={autotaxShortLogoSrc} />
  )
}
